// extracted by mini-css-extract-plugin
export default {"menu":"za","button":"Aa","buttonIcon":"Ba","list":"Ca","buttonActive":"Da","listWrapper":"Ea"};